<template>
    <div class="p-relative">

        <Toolbar v-on:toolbar-button-click="onToolbarClick" />

        <v-form class="wrapperForm" ref="form" lazy-validation>
            <ejs-gantt 
                :dataSource="ganttData" 
                :taskFields="taskSettings"
                :timelineSettings="timelineSettings"
                :splitterSettings="splitterSettings"
                locale="ru"
                >
            </ejs-gantt>   
            <!--:height="'860px'"-->
        </v-form>


    </div>
</template>

<script>
//import i18n from '@/i18n';
import Toolbar from '@/components/documents/Toolbar.vue';
import { registerLicense } from "@syncfusion/ej2-base";
import { GanttPlugin, GanttComponent, Toolbar as GanttToolbar, Edit, Selection } from '@syncfusion/ej2-vue-gantt';
registerLicense("Ngo9BigBOggjGyl/Vkd+XU9FcVRDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3tSdkVhWXdbeXVST2ZUUk91Xg==");

import { L10n, setCulture } from '@syncfusion/ej2-base';
setCulture('ru');
// Загружаем словарь переводов
L10n.load({
    'ru': {
        'gantt': {
            'id': 'Индекс',
            'name': 'Название',
            'startDate': 'Дата начала',
            'endDate': 'Дата окончания',
            'duration': 'Длительность',
            'progress': 'Прогресс',
            'dependency': 'Зависимость',
            'add': 'Добавить',
            'edit': 'Изменить',
            'delete': 'Удалить',
            'update': 'Обновить',
            'cancel': 'Отмена',
            'search': 'Поиск',
            'taskLabels': 'Метки задач',
            'days': 'дн.',
            'hours': 'ч.',
            'minutes': 'мин.'
        },
        'grid': {
            'EmptyRecord': 'Записей для отображения нет',
            'True': 'Истина',
            'False': 'Ложь'
        }
    }
});

import { loadCldr } from '@syncfusion/ej2-base';

function loadCustomCulture(locale) {
  loadCldr({
    "main": {
      [locale]: {
        "dates": {
          "calendars": {
            "gregorian": {
              "months": {
                "format": {
                    "abbreviated": { "1": "янв.", "2": "февр.", "3": "мар.", "4": "апр.", "5": "май", "6": "июнь", "7": "июль", "8": "авг.", "9": "сент.", "10": "окт.", "11": "нояб.", "12": "дек." },
                    "wide": { "1": "Январь", "2": "Февраль", "3": "Март", "4": "Апрель", "5": "Май", "6": "Июнь", "7": "Июль", "8": "Август", "9": "Сентябрь", "10": "Октябрь", "11": "Ноябрь", "12": "Декабрь" }
                    },
                    "stand-alone": {
                    "wide": { "1": "Январь", "2": "Февраль", "3": "Март", "4": "Апрель", "5": "Май", "6": "Июнь", "7": "Июль", "8": "Август", "9": "Сентябрь", "10": "Октябрь", "11": "Ноябрь", "12": "Декабрь" },
                    "abbreviated": { "1": "янв.", "2": "февр.", "3": "мар.", "4": "апр.", "5": "май", "6": "июнь", "7": "июль", "8": "авг.", "9": "сент.", "10": "окт.", "11": "нояб.", "12": "дек." }
                    }
                },
                days: {
                        format: {
                            wide: { "sun": "воскресенье", "mon": "понедельник", "tue": "вторник", "wed": "среда", "thu": "четверг", "fri": "пятница", "sat": "суббота" },
                            abbreviated: { "sun": "вс", "mon": "пн", "tue": "вт", "wed": "ср", "thu": "чт", "fri": "пт", "sat": "сб" },
                            short: { "sun": "вс", "mon": "пн", "tue": "вт", "wed": "ср", "thu": "чт", "fri": "пт", "sat": "сб" },
                            // Добавляем narrow — это то, что он ищет для формата в одну букву
                            narrow: { "sun": "В", "mon": "П", "tue": "В", "wed": "С", "thu": "Ч", "fri": "П", "sat": "С" }
                        },
                        "stand-alone": {
                            wide: { "sun": "воскресенье", "mon": "понедельник", "tue": "вторник", "wed": "среда", "thu": "четверг", "fri": "пятница", "sat": "суббота" },
                            abbreviated: { "sun": "вс", "mon": "пн", "tue": "вт", "wed": "ср", "thu": "чт", "fri": "пт", "sat": "сб" },
                            short: { "sun": "вс", "mon": "пн", "tue": "вт", "wed": "ср", "thu": "чт", "fri": "пт", "sat": "сб" },
                            narrow: { "sun": "В", "mon": "П", "tue": "В", "wed": "С", "thu": "Ч", "fri": "П", "sat": "С" }
                        }
                },
              "dayPeriods": { "format": { "wide": { "am": "am", "pm": "pm" } } },
              "eras": { "eraAbbreviated": { "0": "BC", "1": "AD" } }
            }
          }
        },
        "numbers": {
          "defaultNumberingSystem": "latn",
          "symbols-numberSystem-latn": { "decimal": ".", "group": ",", "percentSign": "%", "plusSign": "+", "minusSign": "-" },
          "decimalFormats-numberSystem-latn": { "standard": "#,##0.###" }
        }
      }
    }
  });
}

loadCustomCulture('ru');
setCulture('ru');

// Базовые стили (кнопки, попапы, рипплы)
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';

// Стили таблицы (левая часть)
import '@syncfusion/ej2-grids/styles/material.css';
import '@syncfusion/ej2-treegrid/styles/material.css';

// Стили самого Ганта (правая часть и общая обертка)
import '@syncfusion/ej2-gantt/styles/material.css';
import '@syncfusion/ej2-layouts/styles/material.css';

import Vue from 'vue';
// Регистрация плагина
Vue.use(GanttPlugin);

export default {
    name: "Profile",
    components: {
        Toolbar,
        'ejs-gantt': GanttComponent  
    },
    provide: {
        // В provide передаем переименованный сервис Syncfusion
        gantt: [GanttToolbar, Edit, Selection]
    },
    data () {
        return {
            ganttData: [
                {
                    TaskID: 1,
                    TaskName: 'Проектирование модуля',
                    StartDate: new Date('2026-04-01'),
                    EndDate: new Date('2026-05-31'),
                    Progress: 70,
                    subtasks: [
                        { TaskID: 2, TaskName: 'Сбор требований', StartDate: new Date('2026-04-10'), Duration: 5, Progress: 100 },
                        { TaskID: 3, TaskName: 'Одобрение ТЗ', StartDate: new Date('2026-04-20'), Duration: 6, Progress: 50 },
                    ]
                },
                {
                    TaskID: 4,
                    TaskName: 'Разработка интерфейса',
                    StartDate: new Date('2026-05-22'),
                    Duration: 3,
                    Progress: 30,
                    Predecessor: '1FS' // Зависимость: начнется после завершения ID 1
                }
            ],
            // Маппинг полей (как Syncfusion должен читать твои объекты)
            taskSettings: {
                id: 'TaskID',
                name: 'TaskName',
                startDate: 'StartDate',
                endDate: 'EndDate',
                duration: 'Duration',
                progress: 'Progress',
                child: 'subtasks', // Ключевое поле для вложенности
                dependency: 'Predecessor' // Для стрелочек связей между задачами
            },
            splitterSettings: {
                position: '50%' // Устанавливает шторку ровно по центру
            },
            timelineSettings: {
                topTier: {
                    unit: 'Month',
                    format: 'MMM' // Результат: Апр., Май, Июнь...
                },
                bottomTier: {
                    unit: 'None' // Вторая строка не нужна
                },
                // Ширину можно немного уменьшить, так как текст стал короче
                timelineUnitSize: 70
                }
        }
    },
    computed: {
        
    },
    
    methods: {
        async onToolbarClick(event, button) {
            if (!button.Action)
                return;

            let action = this[button.Action];

            if (action)
                action(button);
        },  
    }
}
</script>